import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=1ae20725&scoped=true"
import script from "./Recibo.vue?vue&type=script&lang=js"
export * from "./Recibo.vue?vue&type=script&lang=js"
import style0 from "./Recibo.vue?vue&type=style&index=0&id=1ae20725&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae20725",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae20725')) {
      api.createRecord('1ae20725', component.options)
    } else {
      api.reload('1ae20725', component.options)
    }
    module.hot.accept("./Recibo.vue?vue&type=template&id=1ae20725&scoped=true", function () {
      api.rerender('1ae20725', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recibo/Recibo.vue"
export default component.exports